module.exports = __webpack_public_path__ + "img/trainingsschema-week-1-1.b34ae309.png";